// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1Glqc","OrderButton":"BuildControls_OrderButton__3bHJR","enable":"BuildControls_enable__2-l2j"};